// extracted by mini-css-extract-plugin
export default {"paymentCard":"PaymentCard_paymentCard__z6hi3","paymentCardContent":"PaymentCard_paymentCardContent__QyFst","number":"PaymentCard_number__hMYRd","title":"PaymentCard_title__cQJ8V"};